export const FETCH_SYSTEM_SETTINGS = "FETCH_SYSTEM_SETTINGS"
export const FETCH_SYSTEM_LOCATIONS = "FETCH_SYSTEM_LOCATIONS"
export const SET_SYSTEM_SUBDOMAIN = "SET_SYSTEM_SUBDOMAIN"
export const TOGGLE_INSTANT_QR_CODE = "TOGGLE_INSTANT_QR_CODE"
export const ADD_DINE_IN_TABLE = "ADD_DINE_IN_TABLE"
export const REMOVE_DINE_IN_TABLE = "REMOVE_DINE_IN_TABLE"
export const ADD_SYSTEM_CASH_TYPE = "ADD_SYSTEM_CASH_TYPE"
export const REMOVE_SYSTEM_CASH_TYPE = "REMOVE_SYSTEM_CASH_TYPE"
export const TOGGLE_TEMPORARY_OFF = "TOGGLE_TEMPORARY_OFF"
export const TOGGLE_AUTO_CONFIRM = "TOGGLE_AUTO_CONFIRM"
export const TOGGLE_AUTO_CHECKOUT = "TOGGLE_AUTO_CHECKOUT"
export const UPDATE_SYSTEM_SETTINGS = "UPDATE_SYSTEM_SETTINGS"
export const UPDATE_PRINTERS = "UPDATE_PRINTERS"
export const TOGGLE_KIOSK_MODE = "TOGGLE_KIOSK_MODE"
export const SET_KIOSK_NUMBER = "SET_KIOSK_NUMBER"
